import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import qs from 'qs';
import './index.css';
import App from './App';
import Cookies from 'js-cookie'
import * as serviceWorker from './serviceWorker';

import { applyMiddleware, createStore, combineReducers } from 'redux';
import { Provider } from 'react-redux';

import createSagaMiddleware from 'redux-saga';
import { all, put } from 'redux-saga/effects';
import { composeWithDevTools } from 'redux-devtools-extension';

import { i18nReducer, syncTranslationWithStore } from "react-redux-i18n";
import './styles.scss';
import 'tippy.js/themes/google.css';

import {
    rootReducer as baseAppReducer,
    sagas as baseAppSagas,
    locales as baseAppLocales
} from './baseApp'

import {
    rootReducer as smartBuildingsReducer,
    sagas as smartBuildingsSagas,
    locales as smartBuildingsLocales
} from './smartBuildings'
import actions from './baseApp/auth/actions';
import actionTypes from './baseApp/actionTypes'
import { data } from 'jquery';

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.withCredentials = true;
axios.defaults.paramsSerializer = (params) => {
    return qs.stringify(params, { arrayFormat: 'repeat', encodeValuesOnly: true })
};

const appReducer = combineReducers({
    i18n: i18nReducer,
    ...baseAppReducer,
    ...smartBuildingsReducer
});

const rootReducer = (state, action) => {
    if (action.type === actionTypes.authActionTypes.LOGIN_SUCCESS) {
        const { i18n } = state;
        state = { i18n };
    }

    return appReducer(state, action)
}

const sagaMiddleware = createSagaMiddleware();
const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(sagaMiddleware)));

const enTranslations = {
    ...baseAppLocales.en,
    ...smartBuildingsLocales.en
};

const ptTranslations = {
    ...baseAppLocales.pt,
    ...smartBuildingsLocales.pt
};

axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (error.response.status === 401 && !error.response.config.url.includes("auth")) {
            sagaMiddleware.run(sessionExpiredSaga)
        }
        return Promise.reject(error);
    }
);

/* if (localStorage.getItem("user_session")) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + JSON.parse(localStorage.getItem("user_session")).sessionToken;
} */


sagaMiddleware.run(i18nFlowSaga);
sagaMiddleware.run(rootSaga);

syncTranslationWithStore(store);

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById("root")
);

export {
    store
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

function* i18nFlowSaga() {
    yield put({
        type: '@@i18n/LOAD_TRANSLATIONS',
        translations: {
            'en-US': enTranslations,
            'pt-PT': ptTranslations
        }
    });
    yield put({
        type: '@@i18n/SET_LOCALE',
        locale: 'en-US'
    });
}

function* rootSaga() {
    yield all([
        ...baseAppSagas,
        ...smartBuildingsSagas
    ]);
}

function* sessionExpiredSaga() {
    yield put(actions.logout(true));
}